import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { initialize } from 'redux-form'
import { get } from 'lodash'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { FORMS } from '../../utils/enums'
import { history } from '../../utils/history'
import ComplaintForm from './forms/ComplaintForm'
import {
	COMPLAINT_STATUS,
	createComplaint,
	getComplaint,
	updateComplaint,
	IComplaintForm, deleteComplaint
} from '../../reducers/complaints/actions'
import { IComputedMatch } from '../../types/interfaces'

interface Props {
	computedMatch: IComputedMatch<{ id: number }>
}

const DetailComplaint = ({ computedMatch }: Props) => {
	const { t } = useTranslation('pages')
	const dispatch = useDispatch()

	const detail = useSelector((state) => get(state, 'complaints.detail'))
	const isLoading = get(detail, 'isLoading')
	const { id } = computedMatch.params

	const initEmptyDetailForm = () => {
		const initValues: IComplaintForm = {
			id: null,
			note: '',
			finishID: null,
			finishLabel: null,
			jobID: null,
			cleanerID: null,
			status: COMPLAINT_STATUS.UNJUSTIFIED
		}
		dispatch(initialize(FORMS.COMPLAINT_FORM, initValues))
	}

	const initDetailForm = (data: IComplaintForm) => {
		dispatch(initialize(FORMS.COMPLAINT_FORM, data))
	}

	const handleRemove = (idToRemove?: number) => {
		if (!idToRemove) return

		dispatch(deleteComplaint(idToRemove, () => {
			history.push(`${t('paths:complaints|path')}`)
		}))
	}

	useEffect(() => {
		if (id) {
			dispatch(getComplaint(id, (data) => {
				const formData: IComplaintForm = {
					id: data.id,
					note: data.note,
					finishID: data.finishID ?? null,
					finishLabel: data.finishLabel ?? null,
					jobID: get(data, 'job.id') ?? null,
					cleanerID: get(data, 'cleaner.id') ?? null,
					status: data.status
				}
				initDetailForm(formData)
			}))
		} else {
			initEmptyDetailForm()
		}
	}, [dispatch, id])

	const handleCreate = (body: IComplaintForm) => {
		dispatch(createComplaint(body, () => history.replace(`${t('paths:complaints|path')}`)))
	}

	const handleUpdate = (body: IComplaintForm) => {
		if (!id) return
		dispatch(updateComplaint(id, body, () => {
			dispatch(getComplaint(id, (data) => {
				const formData: IComplaintForm = {
					id: data.id,
					note: data.note,
					finishID: data.finishID ?? null,
					finishLabel: data.finishLabel ?? null,
					jobID: get(data, 'job.id') ?? null,
					cleanerID: get(data, 'cleaner.id') ?? null,
					status: data.status
				}
				initDetailForm(formData)
			}))
		}))
	}

	const handleSubmit = (values: IComplaintForm) => {
		const body: IComplaintForm = {
			id: null,
			note: values.note,
			jobID: values.jobID,
			finishID: values.finishID,
			finishLabel: values.finishLabel,
			status: values.status,
			cleanerID: values.cleanerID
		}
		if (id) {
			handleUpdate(body)
		} else {
			handleCreate(body)
		}
	}

	return (
		<div className={'page-wrapper'}>
			<Spin spinning={isLoading}>
				<ComplaintForm
					onSubmit={handleSubmit}
					onRemove={handleRemove}
					isCreate={!id}
					id={id}
				/>
			</Spin>
		</div>
	)
}

export default DetailComplaint
